// import Swiper core, modules, and css

import { logDiskoSignature } from './disko-signature.js'
import { Megamenu } from './Megamenu.js'
import { Footer } from './Footer.js'
import { observeBlocks } from './BlocksObserver.js'
import { expandOrRetractDetails, breadcrumbDisplayQuery } from './breadcrumb.js'
import { refreshTPID } from './thematic-path'
import { makeDownloadableResourceSelectReactive, observeResourceStickyDownloadBtn } from './downloadableResource'

// import { Expandable } from './Expandable'

import { dataLayer } from './dataLayer.js'

document.addEventListener('DOMContentLoaded', (event) => {
    const $mainNavigation = document.body.querySelector('.navigation-container')
    if ($mainNavigation) $mainNavigation.expandygg = new Megamenu({
        burger: {
            button: '#burger-btn',
            target: '#mainmenu',
        },
        container: '.navigation-container',
        desktopBreakpoint: '(min-width: 783px)',
        expandableRegionsSelector: '[data-submenu-region]',
    })
    
    // set listener...
    breadcrumbDisplayQuery.addEventListener('change', expandOrRetractDetails, {capture: false, passive: true, once: false} || false)
    // ...and trigger it right away
    expandOrRetractDetails(breadcrumbDisplayQuery)
    
    
    refreshTPID()
    
    observeBlocks()
    
    makeDownloadableResourceSelectReactive()
    
    observeResourceStickyDownloadBtn()
    
    const $footer = document.querySelector('footer[role="contentinfo"]')
    if ($footer) $footer.expandygg = new Footer({
        accordions: {
            regionsSelector: '.footer-menu__accordion-region',
            desktopBreakpoint: '(min-width: 768px)'
        }
    })
    
    
    
    dataLayer()
    
    logDiskoSignature()
    
}, {capture: false, passive: true, once: true} || false)

